// Duyuru ekleri: görsel önizleme + PDF/görsel açma-indirme (yetkili blob ile)
import { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, Download, Paperclip } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const fileSize = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);
const fetchBlob = (aid, att) => axios.get(`${API}/announcement-files/${aid}/${att.id}`, { responseType: 'blob' }).then(r => URL.createObjectURL(r.data));

const Thumb = ({ aid, att }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    fetchBlob(aid, att).then(u => { url = u; setSrc(u); }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [aid, att.id]);
  return src ? <img src={src} alt={att.name} className="h-full w-full object-cover" /> : <div className="h-full w-full animate-pulse bg-slate-100" />;
};

export const AnnouncementAttachments = ({ aid, attachments }) => {
  if (!attachments?.length) return null;
  const open = async (att, download) => {
    const url = await fetchBlob(aid, att);
    if (download) Object.assign(document.createElement('a'), { href: url, download: att.name }).click();
    else window.open(url, '_blank', 'noopener');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };
  return (
    <div className="space-y-2" data-testid={`ann-attachments-${aid}`}>
      <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-slate-500"><Paperclip className="h-3.5 w-3.5" />Ekler ({attachments.length})</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {attachments.map(att => (
          <div key={att.id} className="flex items-center gap-3 rounded-lg border bg-white p-2 transition-shadow hover:shadow-sm" data-testid={`ann-att-${att.id}`}>
            <button type="button" onClick={() => open(att, false)} className="h-12 w-12 shrink-0 overflow-hidden rounded-md border bg-slate-50 flex items-center justify-center" title="Aç" data-testid={`ann-att-open-${att.id}`}>
              {att.content_type.startsWith('image/') ? <Thumb aid={aid} att={att} /> : <FileText className="h-6 w-6 text-rose-600" />}
            </button>
            <button type="button" onClick={() => open(att, false)} className="min-w-0 flex-1 text-left">
              <span className="block truncate text-sm font-medium text-slate-800">{att.name}</span>
              <span className="text-xs text-slate-400">{fileSize(att.size)}</span>
            </button>
            <button type="button" onClick={() => open(att, true)} className="rounded-md p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-800" title="İndir" data-testid={`ann-att-download-${att.id}`}><Download className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
